async function getServicesHome() {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/services?populate=image`,
    );
    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}

export default getServicesHome;
